<template>
    <div class="gray-back" style="padding:.2rem 0 0 0 ; height: 100%">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <div v-for="(member,index) in row.member_list" :key="index">
                <van-cell-group>
                    <van-cell
                            readonly
                            input-align="right"
                            :title="'人员'+(index+1)"
                            :label="member.num"
                            :value="member.name"
                    >
                        </van-cell>
   
                    <van-cell
                            :is-link="member.daoshioptions.length>0"
                            title="导师等级申报"
                            :value="member.daoshishenbao"
                            :label="'现有等级 '+(member.daoshi?member.daoshi:'无')"
                            @click="thisMemberIndex = index;thisMemberField = 'daoshishenbao';shenbaoTypeColumns = member.daoshioptions; showShenbaoTypePicker=true"
                            input-align="right">
                    </van-cell>
                </van-cell-group>
 

                <!-- <div style="padding:20px; font-size:14px; color: #444;line-height:30px;">

                    <p style="text-align:center;font-weight:bold">申报标准说明</p> 
                    正在完善中
                </div> -->

            </div>


            <div style="height: 100px"></div>

            <div class="savebtn">

                <van-button
                        style="width: 3rem"
                        size="normal" round @click="goPre()">上一步</van-button>

                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>


        <van-popup v-model="showShenbaoTypePicker" v-if="shenbaoTypeColumns.length>0" position="bottom">
            <van-picker :columns="shenbaoTypeColumns"
                        show-toolbar
                        :default-index="0"
                        @cancel="showShenbaoTypePicker = false"
                        @confirm="onShenbaoTypeConfirm"
            />
        </van-popup>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }

</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Dialog,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    import SubjectJiaolianPicker from '@/components/picker/SubjectJiaolianPicker.vue';
    import YundongyuanPicker from '@/components/picker/YundongyuanPicker.vue';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button).use(Dialog);
    export default {
        name: 'HuiyiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                playMusicUrl:'',
                thisMemberIndex:0,
                thisMemberField:'',
                saveLoading:false,
                showNumTypePicker:false,
                showShenbaoTypePicker:false,
                addShow:false,
                show_share_panel:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                thismember:{
                },
                copy_text:'cccc',
                areaValue:'',
                submitType:'',
                shenbaoTypeColumns:[],
                row:{
                    id:0,
                    member_list:[],
                    grade_pics:[],
                    service_options:[],
                    shenbaotype:[],
                },
                formData: {
                    name:'',
                    num:'',
                    cardtype:1,
                    numTypeName:'身份证',
                },
            }
        },
        filters: {},
        mounted() {
            document.title = '导师申报';

            let that = this;
            that.areaList = area;
            that.row.id = this.$route.query.id;
            if(that.row.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        computed:{
//            shenbaoTypeColumns(){
//                return [];
                /*
                 this.row.service_options.map(item =>{
                 return item.name;
                 })
                 */
//            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onShenbaoTypeConfirm(value,index){
                this.row.member_list[this.thisMemberIndex][this.thisMemberField] = value;
                console.log(this.thisMemberField);
                if(this.thisMemberField == 'caipanshenbaowudao'){
                    //舞蹈 技巧只能同时申报一项
                    if(this.row.member_list[this.thisMemberIndex]['caipanshenbaojiqiao']){
                       // Toast('裁判舞蹈、技巧只能同时申报一项');
                    }
                    //this.row.member_list[this.thisMemberIndex]['caipanshenbaojiqiao'] = '';
                }else if(this.thisMemberField == 'caipanshenbaojiqiao'){
                    if(this.row.member_list[this.thisMemberIndex]['caipanshenbaowudao']){
                       // Toast('裁判舞蹈、技巧只能同时申报一项');
                    }
                    //this.row.member_list[this.thisMemberIndex]['caipanshenbaowudao'] = '';
                }

                else if(this.thisMemberField == 'jiaolianshenbaowudao'){
                    if(this.row.member_list[this.thisMemberIndex]['jiaolianshenbaojiqiao']){
                      //  Toast('教练舞蹈、技巧只能同时申报一项');
                    }
                    //this.row.member_list[this.thisMemberIndex]['jiaolianshenbaojiqiao'] = '';
                }

                else if(this.thisMemberField == 'jiaolianshenbaojiqiao'){
                    if(this.row.member_list[this.thisMemberIndex]['jiaolianshenbaowudao']){
                       // Toast('教练舞蹈、技巧只能同时申报一项');
                    }
                    //this.row.member_list[this.thisMemberIndex]['jiaolianshenbaowudao'] = '';
                }
                this.showShenbaoTypePicker = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                let valiOk = true;

                if(!valiOk){
                    return ;
                }

                that.saveLoading = true;

                that.$api.post('/api/huiyi/step41save', {
                    'baoming_id' : that.row.id,
                    'grade_pics' :that.row.grade_pics,
                    'member_list' :that.row.member_list.map(item =>{
                        return {
                            'id' : item.id||0,
                            'daoshi':item.daoshi,
                            'daoshishenbao':item.daoshishenbao,  
                        }
                    })
                }, (res) => {

                    appEvent({
                        name: 'saiApplyDetailReload',
                        query: {
                        }
                    });

                    setTimeout(function () {
                        rbLink({
                            name:'HuiyiApplyFormStep5',
                            query:{
                                id: that.row.id
                            }
                        })
                    },50);
                    that.saveLoading = false;
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/huiyi/step41detail', {
                    id:that.row.id
                }, (res) => {
                    that.row = res.data;
                    that.row.member_list.map(item  =>{
                    })

                }, (res) => {
                    Toast.fail(res.msg);
                })
            },


            shareWeixinFriend(){
                console.log('shareWeixinFriend')
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinFriend',
                        query: that.row.share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;
                }
            },
            shareWeixinTimeLine(){
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinTimeLine',
                        query: that.row.share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;

                }
            },

            goPre(){
                let that =this;
                rbLink({
                    name:'HuiyiApplyFormStep2',
                    query:{
                        id:that.row.id
                    }
                },'replace')
            },

        }
    }
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormStep20.vue?5e8afeb7